import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./Onboarding.module.css";
import { TenantSetupModal } from "../../components";
import { Button } from "../../components/ui";
import { useAuth } from "../../auth/AuthContext";

/**
 * Onboarding obrigatório — a saída de quem entrou por "Continuar com Google".
 *
 * O login social entrega um `User` sem `Tenant`. Antes desta tela, esse usuário
 * caía em `/visao-geral` e via uma página vazia: sem erro, sem explicação e sem
 * caminho para frente. Aqui ele encontra o wizard já aberto e, se fechá-lo, uma
 * página que diz o que falta e como retomar.
 *
 * Fica FORA do `AppLayout` de propósito: o menu lateral é construído a partir do
 * segmento do tenant, e não há tenant — a sidebar apareceria vazia ou pela
 * metade, oferecendo navegação para telas que ainda não têm dado nenhum.
 */
export default function Onboarding() {
  const navigate = useNavigate();
  const { logout } = useAuth();
  const [isModalOpen, setIsModalOpen] = useState(true);

  const handleSuccess = () => {
    setIsModalOpen(false);
    // O `TenantSetupModal` já refrescou o contexto antes de chamar `onSuccess`,
    // então a guarda de `/visao-geral` enxerga o tenant novo e deixa passar.
    navigate("/visao-geral", { replace: true });
  };

  // INV-F2: o único "encerrar sessão" é `clearSession()`, chamado pelo
  // `logout()` do contexto. Esta tela não remove chave de storage por conta
  // própria — só oferece a porta.
  const handleLogout = () => {
    logout();
    navigate("/login", { replace: true });
  };

  return (
    <main className={styles.page}>
      <section className={styles.card}>
        <span className={styles.badge}>Falta um passo</span>
        <h1 className={styles.title}>Vamos configurar seu negócio</h1>
        <p className={styles.text}>
          Sua conta foi criada, mas ainda não sabemos que tipo de negócio você
          atende. Sem isso não dá para montar sua agenda nem treinar o
          atendimento da IA — leva menos de um minuto.
        </p>
        <div className={styles.actions}>
          <Button variant="primary" onClick={() => setIsModalOpen(true)}>
            Configurar meu negócio
          </Button>
          <Button variant="ghost" onClick={handleLogout}>
            Sair da conta
          </Button>
        </div>
      </section>

      {isModalOpen && (
        <TenantSetupModal
          onSuccess={handleSuccess}
          onClose={() => setIsModalOpen(false)}
        />
      )}
    </main>
  );
}
